// frontend/src/patient/ActivePatientContext.js
//
// Globalt "aktiv patient"-kontext (Spår Q, beslut 2026-08-25): när en
// patientjournal öppnas följer patienten med i appen. Providern bor OVANFÖR
// routern (i AppContent) och överlever därför all navigering — man kan gå till
// Bokningar eller startsidan utan att patienten "släpps", precis som det
// globala inspelningskontextet (se recording/RecordingContext.js).
//
// ActivePatientWidget (syns på alla sidor) och AppointmentModal (förifyller
// den aktiva patienten i nya bokningar) är bara konsumenter av kontextet.
// Endast opak patientdata i klientminnet — inget lämnar webbläsaren och
// "Stäng journal" (clearActivePatient) rensar det helt.

import React, { createContext, useContext, useState, useCallback } from 'react';

const ActivePatientContext = createContext(null);

export const useActivePatient = () => useContext(ActivePatientContext);

export function ActivePatientProvider({ children }) {
  // null | { patient_id, firstname, lastname, fullname, personnummer, id_type, email, phone }
  const [activePatient, setActivePatientState] = useState(null);

  // Normaliserar patientobjektet så konsumenter (t.ex. bokningsmodalen som
  // visar fullname/personnummer/email/phone) alltid får samma form.
  const setActivePatient = useCallback((patient) => {
    if (!patient?.patient_id) return;
    const firstname = patient.firstname || '';
    const lastname = patient.lastname || '';
    setActivePatientState({
      patient_id: patient.patient_id,
      firstname,
      lastname,
      fullname: patient.fullname || `${firstname} ${lastname}`.trim(),
      personnummer: patient.personnummer || '',
      id_type: patient.id_type || 'personnummer',
      email: patient.email || '',
      phone: patient.phone || '',
    });
  }, []);

  const clearActivePatient = useCallback(() => {
    setActivePatientState(null);
  }, []);

  const value = { activePatient, setActivePatient, clearActivePatient };

  return (
    <ActivePatientContext.Provider value={value}>
      {children}
    </ActivePatientContext.Provider>
  );
}
